import React from 'react';
import { connect } from "react-redux";
import { createStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import { CircularProgress, Grid } from '@material-ui/core';
import InfiniteScroll from "react-infinite-scroll-component";
import queryString from 'query-string';

// Redux
import { fetchVendorEvaluation } from "redux/evaluate/action";
import { deleteProductReview } from "redux/product/orgProduct/action";
// Views
import AppBarV2 from "Components/Application/AppBarV2";

// Common
import VendorEvaluationCard from "Components/Common/VendorEvaluationCard"
import deleteIcon from "assets/images/delete.svg";
import Image from 'Components/Common/image';
import classnames from "classnames";
import MessageDialog from "Components/Common/MessageDialog";
import {
  showMessageDialog,
  hideMessageDialog,
} from "redux/applications/action";

// Redux
const connectedProps = (state) => (
  {
    vendorEvaluations: state.evaluate.vendorEvaluations,
    vendorEvaluationInProgress: state.evaluate.vendorEvaluationInProgress,
    deleteProductReviewProgress: state.orgProduct.deleteProductReviewProgress,
    deleteProductReviewError: state.orgProduct.deleteProductReviewError,
    userType: state.authUser.user?.Role,
  }
);

const connectionActions = {
  fetchVendorEvaluation: fetchVendorEvaluation,
  deleteProductReview: deleteProductReview,
  showMessageDialog: showMessageDialog,
  hideMessageDialog: hideMessageDialog,
};

// Styles
const styles = (theme) => createStyles({
  containerVendorEvaluation: {
    height: '100%',
    position: 'relative'
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 9999
  },
  NoMoreData: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  btnReview:{
    width: '38px',
    height: '32px',
    border: 'none',
    borderRadius: '5px',
    background:'transparent',
    cursor: 'pointer',
    textAlign: 'center',
    fontSize: '13px',
    color: '#626675',
    marginRight: 10,
    right: '2px',
    position: 'absolute',
    top: 50,
    zIndex: 12
  },
  cardSection: {
    position: 'relative'
  },
  content: {
    padding: theme.spacing(4, 10),
    background: "#F7F7F7",
    minHeight: "100vh"
},  
});


var connector = connect(connectedProps, connectionActions);

const users = [
  {
    name: 'Mohan Kumar'
  },
  {
    name: 'Praveen'
  },
  {
    name: 'Siva prakash'
  }
]

class VendorEvaluationCards extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 18,
      status: [],
      queryParams: queryString.parse(this.props.location.search),
      deleteId: null
    }
  }

  componentDidMount() {
    this.fetchVendorData(true);
  }

  fetchVendorData =(onInit = false)=> {
    const query_type = this.state.queryParams?.type?.split(',').map( Number ) || [];

    let query = Object.assign(this.state)
    query.onInit = onInit
    if(this.props.layout === 'inProgress'){
      query.status = [2,3]
      query.type = query_type ? query_type : [1]
    }else if(this.props.layout === 'completed'){
      query.status = [4,5]
      query.type = query_type ? query_type : [1]
    }
    this.props.fetchVendorEvaluation(query);
  }

  componentDidUpdate(prevProps){
    if(!this.props.deleteProductReviewProgress && prevProps.deleteProductReviewProgress) {
      if(!this.props.deleteProductReviewError) {
        const scope = this
        this.setState({ page: 0 }, () => {
          scope.fetchVendorData(true);
        });
      } else {
          this.setState({error: this.props.deleteProductReviewError});
          setTimeout(() => {
              this.setState({error: null});
          }, 2000)
      }
    }
  }

  routeChange = (item,id) => {
    let redirectPath = '';
    if(item.WorkflowID === null || item.WorkflowID === ''){
      redirectPath = `/app/evaluate/${id}/`;
      this.props.history.push(redirectPath);
    }else{
      redirectPath = `/app/evaluate/${id}/workflow/interim`;
      this.props.history.push(redirectPath);
    }
  }

  deleteReview(id) {
    var me = this;
    this.setState({deleteId: id}, () => {
        me.props.showMessageDialog();
    })
}

  callBack = () => {
    if (this.state.deleteId) {
      this.props.hideMessageDialog();
      this.props.deleteProductReview(this.state.deleteId);
    }
  };

  render() {
    let messageData = {
      head: "Are you sure?",
      subHead: "Do you really want to delete? This process cannot be undone.",
      firstBtn: "Cancel",
      secondBtn: "Yes",
    };

    let userRole = ["OrgAdmin","OrgManager"];
    const adminFlag = userRole.indexOf(this.props.userType) > -1;

    const vendorEvaluations = this.props.vendorEvaluations && this.props.vendorEvaluations.Data || [];
    const dataLength = vendorEvaluations.length || 0;
    
    const classes = this.props.classes;

    let products = [];
    vendorEvaluations.map((item, i) => {
      products.push(
        <Grid item xs={6} sm={6} md={4} lg={2} xl={2} key={i} ref={ (divElement) => { this.divElement = divElement } } className={classes.cardSection}>
          { adminFlag && <button type="button" className={classnames(classes.btnReview, classes.deleteIcon)} onClick={() => this.deleteReview(item.ID)}><Image 
              src={deleteIcon}
              alt="forgotpassword_image" 
              className={classes.titleImage}
          /></button> }
          <VendorEvaluationCard 
            layout={this.props.layout}
            numLayer={1}
            {...item}
            onClick={() => this.routeChange(item,item.ID)}
            users={users}
            queryParams={this.state.queryParams}
            />
        </Grid>
        );
    });

    return <React.Fragment>
      <div className={classes.containerVendorEvaluation}>

        <AppBarV2 title={this.props.title} withBack={true} dropdown={true}/>

        <div  id="scrollableDiv" className={classes.content}>
          <InfiniteScroll
              dataLength={dataLength}
              style={{ display: "flex", flexDirection: "column", overflow: "hidden", marginRight: 20 }} 
              next={()=>{
                let scope = this;
                this.setState({ page: this.state.page + 1 }, () => {
                  scope.fetchVendorData(false);
                });
              }}
              hasMore={
                vendorEvaluations.length === (this.state.page + 1) * this.state.pageSize
              }
              >
                <Grid container spacing={3}>
                  {products}
                </Grid>
            </InfiniteScroll>
        </div>

        { this.props.vendorEvaluationInProgress &&
          <span className={classes.loader}><CircularProgress /></span>
        }
        { !this.props.vendorEvaluationInProgress && vendorEvaluations.length === 0 &&
          <span className={classes.NoMoreData}>No more data </span>
        }

      </div>
      <MessageDialog messageData={messageData} callBack={this.callBack} />
    </React.Fragment>;
  }
}

export default connector(compose(withStyles(styles))(VendorEvaluationCards));
